import { match } from 'ts-pattern';
import type { FilterConfigItemBasic } from '../../../../../../lib/api/filterConfig';
import ClinicalRecency from '../../CustomFilterComponents/ClinicalRecency';
import { IncludeExcludeFilter } from '../../CustomFilterComponents/IncludeExcludeFilter';
import RangeDualSlider from '../../CustomFilterComponents/RangeDualSlider';
import ToggleFilterWithRecency from '../../CustomFilterComponents/ToggleFilterWithRecency';
import YesNoToggleFilters from '../../CustomFilterComponents/YesNoToggleFilters';
import type { FilterConfigItem } from '../FilterConfigTypes';
import { IABTreeFilter, MeshTreeFilter } from './ThrotleFilterConfigubGroupItems';

const yesNoToggle = (filterName: string) => <YesNoToggleFilters filterName={filterName} />;

const extendFilter = (filter: FilterConfigItemBasic) => {
  const filterConfigExtension = match<FilterConfigItem | null>(filter)
    .with({ filterName: 'age_range' }, () => ({
      customComponent: <ToggleFilterWithRecency filterName="age_range" />,
    }))
    .with({ filterName: 'animal' }, () => ({
      customComponent: yesNoToggle('animal'),
    }))
    .with({ filterName: 'auto_work' }, () => ({
      customComponent: yesNoToggle('auto_work'),
    }))
    .with({ filterName: 'baseball' }, () => ({
      customComponent: yesNoToggle('baseball'),
    }))
    .with({ filterName: 'basketball' }, () => ({
      customComponent: yesNoToggle('basketball'),
    }))
    .with({ filterName: 'boating_or_sailing' }, () => ({
      customComponent: yesNoToggle('boating_or_sailing'),
    }))
    .with({ filterName: 'bookbuyer' }, () => ({
      customComponent: yesNoToggle('bookbuyer'),
    }))
    .with({ filterName: 'camping_or_hiking' }, () => ({
      customComponent: yesNoToggle('camping_or_hiking'),
    }))
    .with({ filterName: 'cars' }, () => ({
      customComponent: yesNoToggle('cars'),
    }))
    .with({ filterName: 'casino_gambling' }, () => ({
      customComponent: yesNoToggle('casino_gambling'),
    }))
    .with({ filterName: 'child0_2' }, () => ({
      customComponent: yesNoToggle('child0_2'),
    }))
    .with({ filterName: 'child11_15' }, () => ({
      customComponent: yesNoToggle('child11_15'),
    }))
    .with({ filterName: 'child16_17' }, () => ({
      customComponent: yesNoToggle('child16_17'),
    }))
    .with({ filterName: 'child3_5' }, () => ({
      customComponent: yesNoToggle('child3_5'),
    }))
    .with({ filterName: 'child6_10' }, () => ({
      customComponent: yesNoToggle('child6_10'),
    }))
    .with({ filterName: 'children' }, () => ({
      customComponent: yesNoToggle('children'),
    }))
    .with({ filterName: 'children_interests' }, () => ({
      customComponent: yesNoToggle('children_interests'),
    }))
    .with({ filterName: 'childrens' }, () => ({
      customComponent: yesNoToggle('childrens'),
    }))
    .with({ filterName: 'christian_or_gospel' }, () => ({
      customComponent: yesNoToggle('christian_or_gospel'),
    }))
    .with({ filterName: 'city' }, () => ({
      customComponent: <IncludeExcludeFilter filterName="city" />,
    }))
    .with({ filterName: 'classical' }, () => ({
      customComponent: yesNoToggle('classical'),
    }))
    .with({ filterName: 'collector_of_some_kind' }, () => ({
      customComponent: yesNoToggle('collector_of_some_kind'),
    }))
    .with({ filterName: 'consumer_electronics' }, () => ({
      customComponent: yesNoToggle('consumer_electronics'),
    }))
    .with({ filterName: 'cooking_gourmet' }, () => ({
      customComponent: yesNoToggle('cooking_gourmet'),
    }))
    .with({ filterName: 'country' }, () => ({
      customComponent: yesNoToggle('country'),
    }))
    .with({ filterName: 'county' }, () => ({
      customComponent: <IncludeExcludeFilter filterName="county" />,
    }))
    .with({ filterName: 'crafts' }, () => ({
      customComponent: yesNoToggle('crafts'),
    }))
    .with({ filterName: 'crafts_hobby_merchandise' }, () => ({
      customComponent: yesNoToggle('crafts_hobby_merchandise'),
    }))
    .with({ filterName: 'current_affairs_politics' }, () => ({
      customComponent: yesNoToggle('current_affairs_politics'),
    }))
    .with({ filterName: 'diet_weight_loss' }, () => ({
      customComponent: yesNoToggle('diet_weight_loss'),
    }))
    .with({ filterName: 'education_level' }, () => ({
      customComponent: <ToggleFilterWithRecency filterName="education_level" />,
    }))
    .with({ filterName: 'entertainment' }, () => ({
      customComponent: yesNoToggle('entertainment'),
    }))
    .with({ filterName: 'environment' }, () => ({
      customComponent: yesNoToggle('environment'),
    }))
    .with({ filterName: 'family_activites' }, () => ({
      customComponent: yesNoToggle('family_activites'),
    }))
    .with({ filterName: 'fishing' }, () => ({
      customComponent: yesNoToggle('fishing'),
    }))
    .with({ filterName: 'fitness' }, () => ({
      customComponent: yesNoToggle('fitness'),
    }))
    .with({ filterName: 'food' }, () => ({
      customComponent: yesNoToggle('food'),
    }))
    .with({ filterName: 'football' }, () => ({
      customComponent: yesNoToggle('football'),
    }))
    .with({ filterName: 'gardening' }, () => ({
      customComponent: yesNoToggle('gardening'),
    }))
    .with({ filterName: 'gender' }, () => ({
      customComponent: <ToggleFilterWithRecency filterName="gender" />,
    }))
    .with({ filterName: 'general_contributor' }, () => ({
      customComponent: yesNoToggle('general_contributor'),
    }))
    .with({ filterName: 'general_hobbyist' }, () => ({
      customComponent: yesNoToggle('general_hobbyist'),
    }))
    .with({ filterName: 'generations_in_household' }, () => ({
      customComponent: <ToggleFilterWithRecency filterName="generations_in_household" />,
    }))
    .with({ filterName: 'golf' }, () => ({
      customComponent: yesNoToggle('golf'),
    }))
    .with({ filterName: 'health' }, () => ({
      customComponent: yesNoToggle('health'),
    }))
    .with({ filterName: 'health_beauty' }, () => ({
      customComponent: yesNoToggle('health_beauty'),
    }))
    .with({ filterName: 'hightechleader' }, () => ({
      customComponent: yesNoToggle('hightechleader'),
    }))
    .with({ filterName: 'hockey' }, () => ({
      customComponent: yesNoToggle('hockey'),
    }))
    .with({ filterName: 'home_improvement' }, () => ({
      customComponent: yesNoToggle('home_improvement'),
    }))
    .with({ filterName: 'home_loan_to_value_ratio' }, () => ({
      customComponent: <RangeDualSlider filterName="home_loan_to_value_ratio" minValue={1} maxValue={999} />,
    }))
    .with({ filterName: 'home_ownership' }, () => ({
      customComponent: <ToggleFilterWithRecency filterName="home_ownership" />,
    }))
    .with({ filterName: 'home_price' }, () => ({
      customComponent: <RangeDualSlider filterName="home_price" minValue={0} maxValue={200000} />,
    }))
    .with({ filterName: 'home_value' }, () => ({
      customComponent: <ToggleFilterWithRecency filterName="home_value" />,
    }))
    .with({ filterName: 'household_credit_range' }, () => ({
      customComponent: <ToggleFilterWithRecency filterName="household_credit_range" />,
    }))
    .with({ filterName: 'hunting' }, () => ({
      customComponent: yesNoToggle('hunting'),
    }))
    .with({ filterName: 'income' }, () => ({
      customComponent: <ToggleFilterWithRecency filterName="income" />,
    }))
    .with({ filterName: 'inferred_household_rank_of_individual' }, () => ({
      customComponent: <RangeDualSlider filterName="inferred_household_rank_of_individual" minValue={1} maxValue={9} />,
    }))
    .with({ filterName: 'internet_buyer' }, () => ({
      customComponent: yesNoToggle('internet_buyer'),
    }))
    .with({ filterName: 'jazz' }, () => ({
      customComponent: yesNoToggle('jazz'),
    }))
    .with({ filterName: 'knitting_or_needlework' }, () => ({
      customComponent: yesNoToggle('knitting_or_needlework'),
    }))
    .with({ filterName: 'language' }, () => ({
      customComponent: <ToggleFilterWithRecency filterName="language" />,
    }))
    .with({ filterName: 'length_of_residence' }, () => ({
      customComponent: <RangeDualSlider filterName="length_of_residence" minValue={1} maxValue={15} />,
    }))
    .with({ filterName: 'magazines_purchased' }, () => ({
      customComponent: yesNoToggle('magazines_purchased'),
    }))
    .with({ filterName: 'mail_order_buyer' }, () => ({
      customComponent: yesNoToggle('mail_order_buyer'),
    }))
    .with({ filterName: 'marital_status' }, () => ({
      customComponent: <ToggleFilterWithRecency filterName="marital_status" />,
    }))
    .with({ filterName: 'membership_warehouse' }, () => ({
      customComponent: yesNoToggle('membership_warehouse'),
    }))
    .with({ filterName: 'moments_iab_decile' }, () => ({
      customComponent: IABTreeFilter,
    }))
    .with({ filterName: 'moments_iab_taxonomy_id' }, () => ({
      customComponent: IABTreeFilter,
    }))
    .with({ filterName: 'moments_mesh_decile' }, () => ({
      customComponent: MeshTreeFilter,
    }))
    .with({ filterName: 'moments_mesh_taxonomy_id' }, () => ({
      customComponent: MeshTreeFilter,
    }))
    .with({ filterName: 'moments_recency_filter' }, () => ({
      customComponent: <ClinicalRecency filterName="moments_recency_filter" label="Moments" />,
    }))
    .with({ filterName: 'mortgageamountinthousands' }, () => ({
      customComponent: <RangeDualSlider filterName="mortgageamountinthousands" minValue={0} maxValue={9999} />,
    }))
    .with({ filterName: 'mortgageloantype' }, () => ({
      customComponent: <ToggleFilterWithRecency filterName="mortgageloantype" />,
    }))
    .with({ filterName: 'motor_cycle' }, () => ({
      customComponent: yesNoToggle('motor_cycle'),
    }))
    .with({ filterName: 'movie' }, () => ({
      customComponent: yesNoToggle('movie'),
    }))
    .with({ filterName: 'music' }, () => ({
      customComponent: yesNoToggle('music'),
    }))
    .with({ filterName: 'nascar' }, () => ({
      customComponent: yesNoToggle('nascar'),
    }))
    .with({ filterName: 'net_worth' }, () => ({
      customComponent: <ToggleFilterWithRecency filterName="net_worth" />,
    }))
    .with({ filterName: 'new_credit_range' }, () => ({
      customComponent: <ToggleFilterWithRecency filterName="new_credit_range" />,
    }))
    .with({ filterName: 'num_credit_lines' }, () => ({
      customComponent: <RangeDualSlider filterName="num_credit_lines" minValue={1} maxValue={9} />,
    }))
    .with({ filterName: 'num_in_household' }, () => ({
      customComponent: <RangeDualSlider filterName="num_in_household" minValue={0} maxValue={15} />,
    }))
    .with({ filterName: 'num_of_adults' }, () => ({
      customComponent: <RangeDualSlider filterName="num_of_adults" minValue={0} maxValue={14} />,
    }))
    .with({ filterName: 'num_of_children' }, () => ({
      customComponent: <RangeDualSlider filterName="num_of_children" minValue={0} maxValue={8} />,
    }))
    .with({ filterName: 'occupation' }, () => ({
      customComponent: <IncludeExcludeFilter label="Occupation" filterName="occupation" />,
    }))
    .with({ filterName: 'occupation_code' }, () => ({
      customComponent: <IncludeExcludeFilter label="Occupation Expanded" filterName="occupation_code" />,
    }))
    .with({ filterName: 'own_swimming_pool' }, () => ({
      customComponent: yesNoToggle('own_swimming_pool'),
    }))
    .with({ filterName: 'owns_investments' }, () => ({
      customComponent: yesNoToggle('owns_investments'),
    }))
    .with({ filterName: 'owns_mutual_funds_cds' }, () => ({
      customComponent: yesNoToggle('owns_mutual_funds_cds'),
    }))
    .with({ filterName: 'owns_stocks_or_bonds' }, () => ({
      customComponent: yesNoToggle('owns_stocks_or_bonds'),
    }))
    .with({ filterName: 'pets' }, () => ({
      customComponent: yesNoToggle('pets'),
    }))
    .with({ filterName: 'pets_own_at_least_one_cat' }, () => ({
      customComponent: yesNoToggle('pets_own_at_least_one_cat'),
    }))
    .with({ filterName: 'pets_own_at_least_one_dog' }, () => ({
      customComponent: yesNoToggle('pets_own_at_least_one_dog'),
    }))
    .with({ filterName: 'photography_and_videography' }, () => ({
      customComponent: yesNoToggle('photography_and_videography'),
    }))
    .with({ filterName: 'political' }, () => ({
      customComponent: yesNoToggle('political'),
    }))
    .with({ filterName: 'political_conservative' }, () => ({
      customComponent: yesNoToggle('political_conservative'),
    }))
    .with({ filterName: 'political_liberal' }, () => ({
      customComponent: yesNoToggle('political_liberal'),
    }))
    .with({ filterName: 'politicals' }, () => ({
      customComponent: <ToggleFilterWithRecency filterName={'politicals'} />,
    }))
    .with({ filterName: 'premium_american_express' }, () => ({
      customComponent: yesNoToggle('premium_american_express'),
    }))
    .with({ filterName: 'premium_discover' }, () => ({
      customComponent: yesNoToggle('premium_discover'),
    }))
    .with({ filterName: 'premium_store_or_retail' }, () => ({
      customComponent: yesNoToggle('premium_store_or_retail'),
    }))
    .with({ filterName: 'premium_visa_or_mastercard' }, () => ({
      customComponent: yesNoToggle('premium_visa_or_mastercard'),
    }))
    .with({ filterName: 'reading_best_selling_fiction' }, () => ({
      customComponent: yesNoToggle('reading_best_selling_fiction'),
    }))
    .with({ filterName: 'reading_children_s' }, () => ({
      customComponent: yesNoToggle('reading_children_s'),
    }))
    .with({ filterName: 'reading_computer' }, () => ({
      customComponent: yesNoToggle('reading_computer'),
    }))
    .with({ filterName: 'reading_cooking_or_culinary' }, () => ({
      customComponent: yesNoToggle('reading_cooking_or_culinary'),
    }))
    .with({ filterName: 'reading_country_lifestyle' }, () => ({
      customComponent: yesNoToggle('reading_country_lifestyle'),
    }))
    .with({ filterName: 'reading_fashion' }, () => ({
      customComponent: yesNoToggle('reading_fashion'),
    }))
    .with({ filterName: 'reading_history' }, () => ({
      customComponent: yesNoToggle('reading_history'),
    }))
    .with({ filterName: 'reading_interior_decorating' }, () => ({
      customComponent: yesNoToggle('reading_interior_decorating'),
    }))
    .with({ filterName: 'reading_medical_or_health' }, () => ({
      customComponent: yesNoToggle('reading_medical_or_health'),
    }))
    .with({ filterName: 'reading_military' }, () => ({
      customComponent: yesNoToggle('reading_military'),
    }))
    .with({ filterName: 'reading_mystery' }, () => ({
      customComponent: yesNoToggle('reading_mystery'),
    }))
    .with({ filterName: 'reading_natural_health_remedies' }, () => ({
      customComponent: yesNoToggle('reading_natural_health_remedies'),
    }))
    .with({ filterName: 'reading_news_finance' }, () => ({
      customComponent: yesNoToggle('reading_news_finance'),
    }))
    .with({ filterName: 'reading_people_or_entertainment' }, () => ({
      customComponent: yesNoToggle('reading_people_or_entertainment'),
    }))
    .with({ filterName: 'reading_romance' }, () => ({
      customComponent: yesNoToggle('reading_romance'),
    }))
    .with({ filterName: 'reading_science_fiction' }, () => ({
      customComponent: yesNoToggle('reading_science_fiction'),
    }))
    .with({ filterName: 'reading_science_or_technology' }, () => ({
      customComponent: yesNoToggle('reading_science_or_technology'),
    }))
    .with({ filterName: 'reading_sports' }, () => ({
      customComponent: yesNoToggle('reading_sports'),
    }))
    .with({ filterName: 'reading_world_news_or_politics' }, () => ({
      customComponent: yesNoToggle('reading_world_news_or_politics'),
    }))
    .with({ filterName: 'refinanceamountinthousands' }, () => ({
      customComponent: <RangeDualSlider filterName="refinanceamountinthousands" minValue={1} maxValue={9999} />,
    }))
    .with({ filterName: 'refinanceloantype' }, () => ({
      customComponent: <ToggleFilterWithRecency filterName="refinanceloantype" />,
    }))
    .with({ filterName: 'regular_american_express' }, () => ({
      customComponent: yesNoToggle('regular_american_express'),
    }))
    .with({ filterName: 'regular_discover' }, () => ({
      customComponent: yesNoToggle('regular_discover'),
    }))
    .with({ filterName: 'regular_visa_or_mastercard' }, () => ({
      customComponent: yesNoToggle('regular_visa_or_mastercard'),
    }))
    .with({ filterName: 'religious' }, () => ({
      customComponent: yesNoToggle('religious'),
    }))
    .with({ filterName: 'religious_inspirational' }, () => ({
      customComponent: yesNoToggle('religious_inspirational'),
    }))
    .with({ filterName: 'rhythm_and_blues' }, () => ({
      customComponent: yesNoToggle('rhythm_and_blues'),
    }))
    .with({ filterName: 'rock_n_roll' }, () => ({
      customComponent: yesNoToggle('rock_n_roll'),
    }))
    .with({ filterName: 'running' }, () => ({
      customComponent: yesNoToggle('running'),
    }))
    .with({ filterName: 'rv_own' }, () => ({
      customComponent: yesNoToggle('rv_own'),
    }))
    .with({ filterName: 'snow_skiing' }, () => ({
      customComponent: yesNoToggle('snow_skiing'),
    }))
    .with({ filterName: 'soho_business' }, () => ({
      customComponent: yesNoToggle('soho_business'),
    }))
    .with({ filterName: 'soft_rock_or_easy_listen' }, () => ({
      customComponent: yesNoToggle('soft_rock_or_easy_listen'),
    }))
    .with({ filterName: 'sports' }, () => ({
      customComponent: yesNoToggle('sports'),
    }))
    .with({ filterName: 'sweepstakes_contest' }, () => ({
      customComponent: yesNoToggle('sweepstakes_contest'),
    }))
    .with({ filterName: 'state_code' }, () => ({
      customComponent: <IncludeExcludeFilter filterName="state_code" />,
    }))
    .with({ filterName: 'tennis' }, () => ({
      customComponent: yesNoToggle('tennis'),
    }))
    .with({ filterName: 'travel' }, () => ({
      customComponent: yesNoToggle('travel'),
    }))
    .with({ filterName: 'travel_business' }, () => ({
      customComponent: yesNoToggle('travel_business'),
    }))
    .with({ filterName: 'travel_cruises' }, () => ({
      customComponent: yesNoToggle('travel_cruises'),
    }))
    .with({ filterName: 'travel_international' }, () => ({
      customComponent: yesNoToggle('travel_international'),
    }))
    .with({ filterName: 'travel_vacation' }, () => ({
      customComponent: yesNoToggle('travel_vacation'),
    }))
    .with({ filterName: 'truck_owner' }, () => ({
      customComponent: yesNoToggle('truck_owner'),
    }))
    .with({ filterName: 'two_or_more_lifestyles' }, () => ({
      customComponent: yesNoToggle('two_or_more_lifestyles'),
    }))
    .with({ filterName: 'valuehunter' }, () => ({
      customComponent: yesNoToggle('valuehunter'),
    }))
    .with({ filterName: 'veteran_in_household' }, () => ({
      customComponent: yesNoToggle('veteran_in_household'),
    }))
    .with({ filterName: 'veterans' }, () => ({
      customComponent: yesNoToggle('veterans'),
    }))
    .with({ filterName: 'voter_indicator' }, () => ({
      customComponent: yesNoToggle('voter_indicator'),
    }))
    .with({ filterName: 'wine_appreciation' }, () => ({
      customComponent: yesNoToggle('wine_appreciation'),
    }))
    .with({ filterName: 'woodworking' }, () => ({
      customComponent: yesNoToggle('woodworking'),
    }))
    .with({ filterName: 'year_structure' }, () => ({
      customComponent: <RangeDualSlider filterName="year_structure" minValue={1800} />,
    }))
    .with({ filterName: 'zip' }, () => ({
      customComponent: <IncludeExcludeFilter filterName="zip" />,
    }))
    .otherwise(() => null);

  return (filterConfigExtension ? { ...filter, ...filterConfigExtension } : filter) as FilterConfigItem;
};

export default extendFilter;
